import account from './account';
import layout  from './layout';
import user    from './user';

const actions = {
	account : account,
	layout  : layout,
	user    : user
};

export default actions;